import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';

import { AppBar, Toolbar, useTheme } from '@mui/material';
import Logo from 'src/components/logo';
import { HEADER } from '../config-layout';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function CompactLayout({ children }: Props) {
  const theme = useTheme();

  return (
    <>
      <AppBar>
        <Toolbar
          sx={{
            justifyContent: 'space-between',
            height: {
              xs: HEADER.H_MOBILE,
              md: HEADER.H_DESKTOP,
            },
            transition: theme.transitions.create(['height'], {
              easing: theme.transitions.easing.easeInOut,
              duration: theme.transitions.duration.shorter,
            }),
          }}
        >
          <Logo />
        </Toolbar>
      </AppBar>
      <Container component="main">
        <Stack
          sx={{
            py: 12,
            m: 'auto',
            maxWidth: 400,
            minHeight: '100vh',
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          {children}
        </Stack>
      </Container>
    </>
  );
}
